import http from '@/http';

const FolhaProducaoService = {
  async getFolhaProducao(dadosFolha, onProgress = null) {
    try {
      const config = onProgress ? {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      } : {};

      const response = await http.post('/api/astec/relatorio/projetos/folha', dadosFolha, config);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar movimentações:", error);
      throw error;
    }
  },
};

export default FolhaProducaoService;
